import { BanzaButtonToggle } from "@products/base-portal-lib";

export default defineNuxtPlugin({
	name: "components",
	order: 1050,
	setup: (nuxtApp) => {
		const { $componentsManager } = nuxtApp.vueApp.config.globalProperties;

		$componentsManager.addSettings({
			components: {
				/**
				 * IMAGES
				 */
				BanzaImg: {
					presets: {
						AccessDenied: {
							attrs: {
								src: "/img/access_denied.svg",
							},
						},
					},
				},
				/**
				 * BUTTONS
				 */
				BanzaButton: {
					class: "kredo-btn",
					attrs: {
						elevation: "0",
					},
					presets: {
						flat: {
							class: "text-white px-8",
							attrs: {
								color: "rgba(var(--v-theme-kredo-gray))",
								variant: "flat",
							},
						},
						["flat-primary"]: {
							preset: "BanzaButton.flat",
							attrs: {
								color: "rgba(var(--v-theme-kredo-orange))",
							},
						},
						["flat-gradient"]: {
							preset: "BanzaButton.flat",
							class: "btn-flat--gradient",
						},
						["flat-gradient-blue"]: {
							preset: "BanzaButton.flat",
							class: "btn-flat--gradient-blue",
						},
						["flat-gradient-apple"]: {
							preset: "BanzaButton.flat",
							class: "btn-flat--gradient-apple",
						},
						save: {
							preset: "BanzaButton.flat-gradient-blue",
						},
						close: {
							class: "px-6",
						},
						cancel: {
							class: "px-6",
						},
						outlined: {
							class: "text-black px-8",
							attrs: {
								color: "rgba(var(--v-theme-kredo-gray))",
								variant: "outlined",
							},
						},
						["outlined-secondary"]: {
							preset: "BanzaButton.outlined",
							attrs: {
								color: "rgba(var(--v-theme-kredo-blue))",
							},
						},
						icon: {
							attrs: {
								rounded: "xl",
							},
						},
					},
				},
				/**
				 * FIELDS
				 */
				BanzaTextEdit: {
					class: "kredo-edit",
					attrs: {
						density: "compact",
						color: "rgba(var(--v-theme-kredo-gray))",
						variant: "outlined",
					},
					slots: {
						clear: {
							icon: {
								attrs: {
									color: "rgba(var(--v-theme-kredo-blue))",
								},
							},
						},
					},
					presets: {
						outlined: {
							attrs: {
								color: "rgba(var(--v-theme-kredo-gray))",
								variant: "outlined",
							},
						},
						["outlined-secondary"]: {
							preset: "BanzaTextEdit.outlined",
							attrs: {
								color: "rgba(var(--v-theme-kredo-blue))",
							},
						},
					},
				},
				BanzaAutoComplete: {
					class: "kredo-edit",
					attrs: {
						density: "compact",
						color: "rgba(var(--v-theme-kredo-gray))",
						variant: "outlined",
					},
					slots: {
						clear: {
							icon: {
								attrs: {
									color: "rgba(var(--v-theme-kredo-blue))",
								},
							},
						},
					},
					presets: {
						outlined: {
							attrs: {
								color: "rgba(var(--v-theme-kredo-gray))",
								variant: "outlined",
							},
						},
						["outlined-secondary"]: {
							preset: "BanzaAutoComplete.outlined",
							attrs: {
								color: "rgba(var(--v-theme-kredo-blue))",
							},
						},
					},
				},
				BanzaCheckbox: {
					class: "kredo-edit",
					attrs: {
						density: "compact",
					},
				},
				BanzaButtonToggle: {
					class: "kredo-btn-toggle",
					attrs: {
						density: "compact",
						color: "rgba(var(--v-theme-kredo-orange))",
					},
				},
			},
		});
	},
});
